/**
 * Web SyncManager Entry Point
 *
 * Creates and exports the SyncManager singleton configured with DexieSyncAdapter.
 * This is the main entry point for the web application.
 *
 * Usage:
 * import { syncManager } from './libs/syncManagerWeb';
 * await syncManager.init();
 */

import { SyncManager } from './SyncManager';
import { DexieSyncAdapter, registerDexieAdapters } from '../services/storage/adapters/dexie';

// Singleton instance
let _syncManager: SyncManager | null = null;
let _syncAdapter: DexieSyncAdapter | null = null;

/**
 * Get the SyncManager singleton for web
 */
export function getSyncManager(): SyncManager {
  if (!_syncManager) {
    // Ensure Dexie adapters are registered
    registerDexieAdapters();

    // Create SyncManager
    _syncManager = new SyncManager();

    // Create and set the platform adapter
    _syncAdapter = new DexieSyncAdapter();
    _syncManager.setPlatformAdapter(_syncAdapter);

    console.log('[Web] SyncManager initialized with DexieSyncAdapter');
  }

  return _syncManager;
}

/**
 * Get the sync adapter (for direct access if needed)
 */
export function getSyncAdapter(): DexieSyncAdapter | null {
  return _syncAdapter;
}

/**
 * Clean up resources
 */
export function destroySyncManager(): void {
  if (_syncManager) {
    _syncManager.destroy();
    _syncManager = null;
  }
  if (_syncAdapter) {
    _syncAdapter.destroy();
    _syncAdapter = null;
  }
}

// Export singleton for convenience
export const syncManager = getSyncManager();
export default syncManager;
